
import { ArrowLeft } from "lucide-react";
import React, { useState } from "react";
import JobCard     from "./JobCard";

export default function JobGrid({ jobs, onToggleDisplayView, jobCount, selectedFilters, onSend, onOpenPremiumModal }) {
  const [selected, setSelected]       = useState(null);
  const resetSelected = () => {
    if (selected)
      setSelected(null)
  }
  return (
    <div className="flex flex-1 flex-col h-full items-center md:py-4 pt-12 w-full overflow-x-hidden gap-2 md:px-10">
      <div
        className=" w-full"
        onClick={resetSelected}>
        <div className="flex items-center w-full mb-4">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => onToggleDisplayView('filters')}>
              <ArrowLeft className="w-4 h-4" />
              <div className="text-sm">Retour à la recherche</div>
          </div>
        </div>
        <div className="pb-4 text-center">
          <h2 className="text-2xl font-bold pb-2"> {jobCount} métiers pour toi ! 🎉</h2>
          <p className="text-sm text-gray-300">Voici ce qui correspond à tes critères</p>
        </div>
        <div className="w-full bg-gray-800 p-4 rounded-lg flex flex-col gap-2 text-xs">
          <div className="text-sm text-gray-300">Basé sur tes critères :</div>
          <div className="bg-gray-800 rounded-lg flex flex-wrap gap-2 text-xs">
              {selectedFilters.categories.map((item) => (
              <div key={item.id} className="px-2 py-1 rounded text-sm font-medium text-xs bg-teal-400/20 text-teal-500">{item.label}</div>
              ))}
              {selectedFilters.qualities.map((item) => (
              <div key={item.id} className="px-2 py-1 rounded text-sm font-medium text-xs bg-blue-400/20 text-blue-500">{item.label}</div>
              ))}
              {selectedFilters.interests.map((item) => (
              <div key={item.id} className="px-2 py-1 rounded text-sm font-medium text-xs bg-purple-400/20 text-purple-500">{item.label}</div>
              ))}
              {selectedFilters.study_levels.map((item) => (
              <div key={item.id} className="px-2 py-1 rounded text-sm font-medium text-xs bg-orange-400/20 text-orange-500">{item.label}</div>
              ))}
          </div>
        </div>
      </div>
      <div className="w-full overflow-y-auto mb-4 flex gap-2 flex-col no-scrollbar">
        {jobs.map(job => (
          <JobCard key={job.objectID} job={job} onOpenPremiumModal={onOpenPremiumModal} selected={selected} setSelected={setSelected} onSend={onSend} overlay={'filters'} />
        ))}
      </div>
    </div>
  );
}